import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  allDepotListSelector,
  depotColourMapSelector,
  depotsVisibleOnMapListSelector,
  fullMapOverlayDateSelector,
} from "../../../reducers/app/selector";
import {
  districtBoundariesForMutlipleDepotsSelector,
  businessUnitFilterSelector,
  allBoundariesForMultipleAreasSelector,
} from "../../../reducers/depot/selector";
import { showMapParcelDataMarkersSelector } from "../../../reducers/map/selector";
import {
  setMapBounds,
  setShowMapParcelDataMarkers,
} from "../../../reducers/map";
import {
  setBoundariesForMultipleDepots,
  setBusinessUnitFilter,
} from "../../../reducers/depot";
import {
  getDepotBounds,
  setUpBoundariesWithDepotKeys,
  filterListByBusinessUnit,
} from "../../../utils/map";
import { ViewIcon } from "../../../assets/icons/ViewIcon";
import { DEPOT_TYPE, SHOW_LABELS } from "../../../constants/switchButtons";
import { SwitchButton } from "./SwitchButton";
import "../Sidebar.css";

export const PostcodeAllocationSidebar = () => {
  const allDepots = useSelector(allDepotListSelector);
  const depotsVisibleOnMapList = useSelector(depotsVisibleOnMapListSelector);
  const depotColourMap = useSelector(depotColourMapSelector);
  const districtBoundaries = useSelector(
    districtBoundariesForMutlipleDepotsSelector
  );
  const businessUnitFilter = useSelector(businessUnitFilterSelector);
  const showMapParcelDataMarkers = useSelector(
    showMapParcelDataMarkersSelector
  );
  const fullMapOverlayDate = useSelector(fullMapOverlayDateSelector);
  const allBoundariesForMultipleAreas = useSelector(
    allBoundariesForMultipleAreasSelector
  );

  const districtBoundariesByDepot =
    setUpBoundariesWithDepotKeys(districtBoundaries);

  const dispatch = useDispatch();

  const DepotList = () => {
    return (
      <div className="depotListContainer">
        {depotsVisibleOnMapList
          .filter((depot) => depot.businessUnit === businessUnitFilter)
          .map((depot) => {
            const depotColourIndex = depotColourMap.findIndex(
              (depotMap) => depotMap.depot === depot.depotCode
            );
            return (
              <div key={depot.depotCode} className="depotListBlock">
                <div
                  className="depotListDepotCode"
                  style={{
                    backgroundColor: `${depotColourMap[depotColourIndex].mapColour}`,
                  }}
                >
                  {depot.depotCode}
                </div>
                <div className="depotListDepotName" title={depot.depotName}>
                  {depot.depotName}
                </div>
                <div className="depotListButtonsContainer">
                  <div
                    className="depotListBlockButton"
                    onClick={() => {
                      dispatch(
                        setMapBounds(
                          getDepotBounds(
                            districtBoundariesByDepot[depot.depotCode]
                          )
                        )
                      );
                    }}
                  >
                    <ViewIcon />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  const onBusinessUnitChange = (businessUnit) => {
    dispatch(setBusinessUnitFilter(businessUnit));
    const sectorBoundaries = filterListByBusinessUnit(
      allBoundariesForMultipleAreas.sectorBoundaries,
      businessUnit
    );
    const districtBoundaries = filterListByBusinessUnit(
      allBoundariesForMultipleAreas.districtBoundaries,
      businessUnit
    );
    dispatch(
      setBoundariesForMultipleDepots({
        sectorBoundaries,
        districtBoundaries,
        allBoundaries: allBoundariesForMultipleAreas,
      })
    );
  };

  const onShowLabelChange = (value) =>
    dispatch(setShowMapParcelDataMarkers(value));

  return (
    <div className="postcodeAllocationContainer">
      <SwitchButton
        title={DEPOT_TYPE.title}
        values={DEPOT_TYPE.values}
        onStateChange={onBusinessUnitChange}
        matchingReduxState={businessUnitFilter}
      />
      {fullMapOverlayDate && (
        <SwitchButton
          title={SHOW_LABELS.title}
          values={SHOW_LABELS.values}
          onStateChange={onShowLabelChange}
          matchingReduxState={showMapParcelDataMarkers}
        />
      )}
      {allDepots.length > 0 && <DepotList />}
    </div>
  );
};
